<script lang="ts" setup>
import { getIconNameByNotificationType } from '~/utils/notificationUtils';
import { NotificationStatusItemProps } from './_types';
import { NotificationActionInfo } from '~/plugins/notificationManager/_types';

const props = defineProps<NotificationStatusItemProps>();
const emit = defineEmits<{
    (e: 'execute'): void;
    (e: 'remove'): void;
}>();

const title = computed(() => {
    activeLocale; // eslint-disable-line @typescript-eslint/no-unused-expressions
    return getNotificationTitle(props.notification);
});

const { activeLocale } = useAppLocale();
const { getNotificationTitle } = useNotifications();

const onExecute = async (a: NotificationActionInfo) => {
    const shouldRemove = await a.executeFn(props.notification);
    if (shouldRemove) {
        emit('remove');
    }
    emit('execute');
};

const onRemove = () => {
    emit('remove');
};
</script>

<template>
    <q-item class="q-pr-sm">
        <q-item-section avatar style="min-width: auto">
            <div
                class="flex flex-center app-notifications"
                :class="`enum-bg-notification-action-type--${notification.Type}`"
                style="width: 28px; height: 28px; border-radius: 50%"
            >
                <q-icon :name="getIconNameByNotificationType(notification.Type)" size="sm" />
            </div>
        </q-item-section>
        <q-item-section class="text-bold">
            <q-item-label>{{ title }}</q-item-label>
            <q-item-label caption style="margin-top: 6px">
                <template v-for="a in actions" :key="a.actionKey">
                    <link-btn
                        v-if="a.canExecuteFn == null || a.canExecuteFn(notification)"
                        class="q-pa-none q-mr-sm text-dense"
                        style="min-height: auto"
                        dense
                        size="1rem"
                        :label="$t(a.label)"
                        :text-color="a.textColor"
                        @click="() => onExecute(a)"
                    />
                </template>
            </q-item-label>
        </q-item-section>
        <q-item-section side>
            <flat-btn icon="las la-times" dense @click="onRemove" size="sm" />
        </q-item-section>
    </q-item>
</template>
